import { useEffect as s, useState as o } from "react";
import { disposables as t } from '../utils/disposables.js';
function p() {
  let [e] = o(t);
  return s(() => () => e.dispose(), [e]), e;
}
export { p as useDisposables };